"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Endorsements = void 0;
class Endorsements {
    constructor(data) {
        this.adulteratedFoodEndorsement = data.adulteratedFoodEndorsement;
        this.limitAdulteratedFoodEndorsement = data.limitAdulteratedFoodEndorsement;
        this.broadDriverEndorsement = data.broadDriverEndorsement;
        this.brokenSealEndorsement = data.brokenSealEndorsement;
        this.limitBrokenSealEndorsement = data.limitBrokenSealEndorsement;
        this.limitedCoverageAdditionalPerils = data.limitedCoverageAdditionalPerils;
        this.employeeDishonestyLimit = data.employeeDishonestyLimit;
        this.corrosionRustLimit = data.corrosionRustLimit;
        this.mobileEquipmentEndorsement = data.mobileEquipmentEndorsement;
        this.limitMobileEquipmentEndorsement = data.limitMobileEquipmentEndorsement;
        this.personalPropertyCoverage = data.personalPropertyCoverage;
        this.personalPropertyLimit = data.personalPropertyLimit;
        this.personalPropertyEmployeesLimit = data.personalPropertyEmployeesLimit;
        this.refrigerationBreakdown = data.refrigerationBreakdown;
        this.inOrOnAnyOneLandVehicleLimit = data.inOrOnAnyOneLandVehicleLimit;
        this.inOrAtScheduledTerminalsLimit = data.inOrAtScheduledTerminalsLimit;
        this.inOrAtUnscheduledTerminalsLimit = data.inOrAtUnscheduledTerminalsLimit;
        this.allPropertyInAnyOneOccurrence = data.allPropertyInAnyOneOccurrence;
        this.trailerInterchange = data.trailerInterchange;
        this.estimatedNumberOfTrailers = data.estimatedNumberOfTrailers;
        this.trailerInterchangeLimit = data.trailerInterchangeLimit;
        this.trailerInterchangeDeductible = data.trailerInterchangeDeductible;
    }
    static empty() {
        const data = {
            adulteratedFoodEndorsement: null,
            limitAdulteratedFoodEndorsement: null,
            broadDriverEndorsement: null,
            brokenSealEndorsement: null,
            limitBrokenSealEndorsement: null,
            limitedCoverageAdditionalPerils: null,
            employeeDishonestyLimit: null,
            corrosionRustLimit: null,
            mobileEquipmentEndorsement: null,
            limitMobileEquipmentEndorsement: null,
            personalPropertyCoverage: null,
            personalPropertyLimit: null,
            personalPropertyEmployeesLimit: null,
            refrigerationBreakdown: null,
            inOrOnAnyOneLandVehicleLimit: null,
            inOrAtScheduledTerminalsLimit: null,
            inOrAtUnscheduledTerminalsLimit: null,
            allPropertyInAnyOneOccurrence: null,
            trailerInterchange: null,
            estimatedNumberOfTrailers: null,
            trailerInterchangeLimit: "",
            trailerInterchangeDeductible: ""
        };
        return new Endorsements(data);
    }
    static fromObj(data) {
        if (!data)
            return Endorsements.empty();
        return new Endorsements(Object.assign({}, data));
    }
}
exports.Endorsements = Endorsements;
//# sourceMappingURL=endorsements.class.js.map